import React, { useEffect } from 'react';

import CenterLolumnLayout from '../../layout/screen';
import './style.scss';
import { Link } from 'react-router-dom';
import PageFooter from '../../components/page-footer';
import { getRulesRoute } from '../../routes';

export default function HomePage() {

    useEffect(() => {
        document.body.classList.add('home-page');

        return () => {
            document.body.classList.remove('home-page');
        }
    })

    return (
        <CenterLolumnLayout footer={PageFooter()}>
            <main className='column home-screen'>
                <h1>Witajcie!</h1>
                <p>
                    Zapraszamy Was na spacer po niewielkim polskim miasteczku. Rozwiązując kolejne zadania, odwiedzicie m. in. rynek z ratuszem, park miejski, bibliotekę, targowisko czy dworzec. W każdym z tych miejsc zmierzycie się z zadaniami związanymi z różnorodnością, tolerancją, relacjami międzygrupowymi. Przyjrzycie się tym zagadnieniom również z perspektywy lokalnego/ej historyka/czki, dziennikarza/ki i aktywisty/ki.
                </p>
                <p>
                    Rozwiązując zadania, pomyślcie o własnej okolicy – mieście, osiedlu, ulicy – dyskusjach, jakie toczycie, problemach, z jakimi się mierzycie. Zastanówcie się nad znaczeniem otwartości w relacjach z innymi ludźmi, budowania relacji opartych na szacunku dla różnorodności i mądrego podejmowania trudnych tematów.
                </p>
                <p>
                    Zagrajcie w <strong>Otwartość</strong> i przekonajcie się, jak różne mogą być jej oblicza.
                </p>
                <p>&nbsp;</p>
                <p className="small">
                    Gra została przygotowana przez Centrum Edukacji Obywatelskiej w ramach programu <br/><strong>Re:Memory – multimedialne historie lokalne</strong>.
                </p>
                <p className="small">
                    scenariusz gry:<br/>
                    Jan Bliźniak, Łukasz Bertram, Katarzyna Górkiewicz<br />
                    gra dostępna na licencji Creative Commons Uznanie autorstwa Na tych samych warunkach 4.0 Międzynarodowe (CC BY-SA 4.0)
                </p>
            </main>
            <nav className="home-nav">
                <div>
                    <Link to={getRulesRoute()} className='button-big'><span>Dalej</span></Link>

                </div>

            </nav>
        </CenterLolumnLayout>
    )
}
